function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Purpose: CHECKMULTISIG opcode — verify M-of-N message signatures.
 */

module.exports = {
  name: 'CHECKMULTISIG',
  description: 'Verify M-of-N signatures',
  exampleScript: {
    op: 'CHECKMULTISIG',
    m: 2,
    publickeys: ['<publickey>', '<publickey>', '<publickey>'],
    msg: '<text>',
    witness: {
      signatures: ['<signature>', '<signature>']
    }
  },
  execute: function execute(node, context) {
    if (!node || _typeof(node) !== 'object' || !context || _typeof(context) !== 'object') {
      return false;
    }
    if (!context.app || !context.app.crypto || typeof context.app.crypto.verifyMessage !== 'function') {
      return false;
    }
    var witness = node.witness;
    if (!witness || _typeof(witness) !== 'object' || Array.isArray(witness)) {
      return false;
    }
    var signatures = witness.signatures;
    if (!Array.isArray(signatures) || signatures.length === 0) {
      return false;
    }
    var publickeys = node.publickeys;
    if (!Array.isArray(publickeys) || publickeys.length === 0) {
      return false;
    }
    var m = Number(node.m);
    var threshold = Number.isFinite(m) && m > 0 ? m : publickeys.length;
    var msg = typeof node.msg === 'string' ? node.msg : '';
    var valid = 0;
    var used = {};
    for (var s = 0; s < signatures.length; s += 1) {
      var signature = signatures[s];
      if (typeof signature !== 'string' || signature.length === 0) {
        continue;
      }
      for (var p = 0; p < publickeys.length; p += 1) {
        var publickey = publickeys[p];
        if (typeof publickey !== 'string' || used[publickey]) {
          continue;
        }
        if (context.app.crypto.verifyMessage(msg, signature, publickey) === true) {
          used[publickey] = true;
          valid += 1;
          break;
        }
      }
      if (valid >= threshold) {
        return true;
      }
    }
    return valid >= threshold;
  }
};